import { useQuery } from "@apollo/client";
import type { ClientNotificationFilter } from "@/__generated__/graphql";
import { ClientNotificationByFiltersDocument } from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";

export const useClientNotificationsQuery = (
  filters: ClientNotificationFilter,
) => {
  const clientId = useAuthState((state) => state.data.userInfo.id);

  const result = useQuery(ClientNotificationByFiltersDocument, {
    skip: !clientId,
    variables: {
      filters,
    },
  });

  const list = result.data?.clientNotificationByFilters?.notifications ?? [];
  const total = result.data?.clientNotificationByFilters?.count ?? 0;
  const canLoadMore = list.length < total;

  return { ...result, list, total, canLoadMore };
};
